import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers/RouterHelpers";
import { toAbsoluteUrl } from "../../../../_helpers";
import SVG from "react-inlinesvg";
import { FaFingerprint, FaUsersCog } from "react-icons/fa";
import { BsPersonLinesFill } from "react-icons/bs";
import { MdDeviceHub, MdDevicesOther } from "react-icons/md";
import { IoIosPeople } from "react-icons/io";
import { GiCardRandom } from "react-icons/gi";
import { VscSymbolStructure } from "react-icons/vsc";
import { useSelector } from "react-redux";
import { FiSettings } from "react-icons/fi";
import { GoReport } from "react-icons/go";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const permissionList = useSelector((state) => state.auth.permissionList);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}

        {permissionList.some((element) => element === "view_employee") && (
          <li
            className={`menu-item  ${getMenuItemActive("/employees", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/employees">
              <span className="svg-icon menu-icon">
                <IoIosPeople />
              </span>
              <span className="menu-text">İnsan resursları</span>
            </NavLink>
          </li>
        )}
        {permissionList.some((element) => element === "view_device") && (
          <li
            className={`menu-item  ${getMenuItemActive("/devices", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/devices">
              <span className="svg-icon menu-icon">
                <MdDevicesOther />
              </span>
              <span className="menu-text">Qurğular</span>
            </NavLink>
          </li>
        )}
        {(permissionList.some((element) => element === "view_employee_log") ||
          permissionList.some((element) => element === "view_biometric_log") ||
          permissionList.some(
            (element) => element === "view_device_operation_report"
          ) ||
          permissionList.some(
            (element) => element === "view_device_report"
          )) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/reports",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/reports">
              <span className="svg-icon menu-icon">
                {/* <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} /> */}
                <GoReport />
              </span>

              <span className="menu-text">Hesabatlar</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className="menu-item  menu-item-parent"
                  aria-haspopup="true"
                >
                  <span className="menu-link">
                    <span className="menu-text">Hesabatlar</span>
                  </span>
                </li>

                {permissionList.some(
                  (element) => element === "view_employee_log"
                ) && (
                  <li
                    className={`menu-item mb-4 ${getMenuItemActive(
                      "/reports/report-employees",
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/reports/report-employees"
                    >
                      <span className="svg-icon menu-icon">
                        <GoReport />
                      </span>
                      <span className="menu-text">Əməkdaşlar üzrə hesabat</span>
                    </NavLink>
                  </li>
                )}
                {permissionList.some(
                  (element) => element === "view_biometric_log"
                ) && (
                  <li
                    className={`menu-item mb-4 ${getMenuItemActive(
                      "/reports/biometric-report",
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/reports/biometric-report"
                    >
                      <span className="svg-icon menu-icon">
                        <GoReport />
                      </span>
                      <span className="menu-text">
                        Biometrik hərəkət hesabat
                      </span>
                    </NavLink>
                  </li>
                )}
                   {permissionList.some(
                  (element) => element === "view_biometric_log"
                ) && (
                  <li
                    className={`menu-item mb-4 ${getMenuItemActive(
                      "/reports/biometric-face",
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/reports/biometric-face"
                    >
                      <span className="svg-icon menu-icon">
                        <GoReport />
                      </span>
                      <span className="menu-text">
                        Biometrik üz hesabatı
                      </span>
                    </NavLink>
                  </li>
                )}
                {permissionList.some(
                  (element) => element === "view_device_operation_report"
                ) && (
                  <li
                    className={`menu-item mb-4 ${getMenuItemActive(
                      "/reports/device-report",
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/reports/device-report">
                      <span className="svg-icon menu-icon">
                        <GoReport />
                      </span>
                      <span className="menu-text">
                        Qurğu əməliyyatları hesabatı
                      </span>
                    </NavLink>
                  </li>
                )}
                {permissionList.some(
                  (element) => element === "view_device_report"
                ) && (
                  <li
                    className={`menu-item  mb-4 ${getMenuItemActive(
                      "/reports/facility-operations-report",
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/reports/facility-operations-report"
                    >
                      <span className="svg-icon menu-icon">
                        <GoReport />
                      </span>
                      <span className="menu-text">Qurğular hesabatı</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/settings",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/settings">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} /> */}
              <FiSettings />
            </span>

            <span className="menu-text">Ayarlar</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Ayarlar</span>
                </span>
              </li>

              {permissionList.some(
                (element) => element === "view_local_structure"
              ) && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/local-structure",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/local-structure">
                    <span className="svg-icon menu-icon">
                      <VscSymbolStructure />
                    </span>
                    <span className="menu-text">Strukturlar</span>
                  </NavLink>
                </li>
              )}
              {permissionList.some((element) => element === "view_duty") && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/duties",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/duties">
                    <span className="svg-icon menu-icon">
                      <BsPersonLinesFill />
                    </span>
                    <span className="menu-text">Vəzifələr</span>
                  </NavLink>
                </li>
              )}
              {permissionList.some((element) => element === "view_user") && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/dashboard",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/dashboard">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                      />
                    </span>
                    <span className="menu-text">İstifadəçilər</span>
                  </NavLink>
                </li>
              )}

              {permissionList.some((element) => element === "view_role") && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/roles",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/roles">
                    <span className="svg-icon menu-icon">
                      <FaUsersCog />
                    </span>
                    <span className="menu-text">Rollar</span>
                  </NavLink>
                </li>
              )}

              {permissionList.some(
                (element) => element === "view_user_permission"
              ) && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/users",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/users">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                      />
                    </span>
                    <span className="menu-text">İstifadəçi icazələri</span>
                  </NavLink>
                </li>
              )}
              {permissionList.some(
                (element) => element === "view_device_place"
              ) && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/device-place",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/device-place">
                    <span className="svg-icon menu-icon">
                      <MdDeviceHub />
                    </span>
                    <span className="menu-text">Qurğu məkanı</span>
                  </NavLink>
                </li>
              )}
              {permissionList.some(
                (element) => element === "view_device_model"
              ) && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/device-model",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/device-model">
                    <span className="svg-icon menu-icon">
                      <MdDevicesOther />
                    </span>
                    <span className="menu-text">Qurğu modeli</span>
                  </NavLink>
                </li>
              )}

              {permissionList.some(
                (element) => element === "view_device_type"
              ) && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/device-type",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/device-type">
                    <span className="svg-icon menu-icon">
                      <MdDevicesOther />
                    </span>
                    <span className="menu-text">Qurğu tipləri</span>
                  </NavLink>
                </li>
              )}
              {permissionList.some(
                (element) => element === "view_device_user"
              ) && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/device-user",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/device-user">
                    <span className="svg-icon menu-icon">
                      <MdDevicesOther />
                    </span>
                    <span className="menu-text">Qurğudakı əməkdaşlar</span>
                  </NavLink>
                </li>
              )}
              {permissionList.some((element) => element === "view_limit") && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/finger-limits",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/finger-limits">
                    <span className="svg-icon menu-icon">
                      <FaFingerprint />
                    </span>
                    <span className="menu-text">Kart və barmaq izi limiti</span>
                  </NavLink>
                </li>
              )}

              {permissionList.some((element) => element === "view_card") && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/settings/cards",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/settings/cards">
                    <span className="svg-icon menu-icon">
                      <GiCardRandom />
                    </span>
                    <span className="menu-text">Kartlar</span>
                  </NavLink>
                </li>
              )}
              {permissionList.some((element) => element === "view_sync") && (
                <li
                  className={`menu-item  ${getMenuItemActive(
                    "/sync-data",
                    false
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/sync-data">
                    <span className="svg-icon menu-icon">
                      <IoIosPeople />
                    </span>
                    <span className="menu-text">Sinxronizasiya ayarları</span>
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </li>
      </ul>
      {/* end::Menu Nav */}
    </>
  );
}
